import { loadModules } from 'esri-loader';


function featureLayerApplyEdits(attrs,rings){

  return loadModules(["esri/layers/FeatureLayer","esri/geometry/SpatialReference","esri/Graphic"]).then(([FeatureLayer,SpatialReference,Graphic]) => {


    const resurfacingFeatureLayer = new FeatureLayer({
      url: process.env.__MAP_SERVER_URLS__.PAVEMENT_OPERATIONAL_FS,
      layerId: 0
    });
    // attrs.UPD_BY = attrs.UPD_BY.length<=20?attrs.UPD_BY : attrs.UPD_BY.substr(0,20);
    // var user = sessionStorage['portalUserId'];
    var user = sessionStorage['portalUserId'];;
    var currentDate = new Date().valueOf();
    attrs.UPD_BY = user.length<=20?user : user.substr(0,20);;
    attrs.UPD_DATE = currentDate;

    var j = {
      "geometry":{"spatialReference":{"latestWkid":2326,"wkid":102140},"rings":[rings]},
      "attributes":attrs
    }
    var g = Graphic.fromJSON(j)

    return resurfacingFeatureLayer.load().then(function(f){
      console.log(f)

      //if have OBJECTID, update feature, else add feature
      if(g.attributes.OBJECTID){
        return f.applyEdits({
          updateFeatures:[g]
        })
      }else{
        return f.applyEdits({
          addFeatures:[g]
        })
      }

    }).otherwise(function (err) {
      console.log("there was an error: ", err);
      return err;
    });



  });

}


function translateRings(rings, xTranslate, yTranslate){

  return rings.map(function(r){
    return [ parseFloat( r[0]) + parseFloat( xTranslate ) ,  parseFloat( r[1] )  + parseFloat( yTranslate) ]
  });

}

function rotateRings(rings, degree){
  return loadModules(["esri/geometry/Polygon","esri/geometry/SpatialReference","esri/geometry/geometryEngine"]).then(([Polygon,SpatialReference,geometryEngine]) => {

    const allRings = [
      [  // first ring
        rings
      ]
     ];

    const polygonToBeRotated = new Polygon({
      hasZ: false,
      hasM: false,
      rings: rings,
      spatialReference: { wkid: 2326 }
    });     
    console.log( geometryEngine.rotate(polygonToBeRotated,degree) )
    return geometryEngine.rotate(polygonToBeRotated,degree)

  });
}

function isSimple(rings){
  return loadModules(["esri/geometry/Polygon","esri/geometry/SpatialReference","esri/geometry/geometryEngine"]).then(([Polygon,SpatialReference,geometryEngine]) => {

    const allRings = [
      [  // first ring
        rings
      ]
     ];

    const polygonToBeChecked = new Polygon({
      hasZ: false,
      hasM: false,
      rings: rings,
      spatialReference: { wkid: 2326 }
    });     
    //debugger;

    //console.log(geometryEngine.simplify(polygonToBeChecked));
    //console.log(polygonToBeChecked)

    return geometryEngine.isSimple(polygonToBeChecked)
    
    /*
    if(  geometryEngine.equals( geometryEngine.simplify(polygonToBeChecked), polygonToBeChecked ) ){
      console.log( geometryEngine.isSimple(polygonToBeChecked) , polygonToBeChecked.isSelfIntersecting )
      return geometryEngine.isSimple(polygonToBeChecked) && !polygonToBeChecked.isSelfIntersecting
    }else{
      console.log( 'simplify diff' )
      return false;
    }*/


  }); 
}


// initial state
// shape: [{ id, quantity }]
const state = {
    featureAttributes: {
      "OBJECTID": null,
      "DEFECT_ID": null,
      "DEFECT_TYPE": null,
      "DATE_REPORTED": null,
      "HD_REF": null,
      "WR_REF": null,
      "PAVE_TYPE": null,
      "LENGTH": null,
      "WIDTH": null,
      "SEVERITY": null,
      "MAINT_ID": null,
      "MATERIAL": null,
      "REMARK": null,
      "PHOTO_LINK": null,
      "REPORT_LINK": null,
      "SR_NO": null,
      "WO_NO":null,
      "AOD": null,
      "UPD_BY": null,
      "UPD_DATE": null,
      "MARK_DELETE": null
    },
    rings:[]
    
  }
  
  // getters
  const getters = {

  }
  
  // actions
  const actions = {
    teardownResurfacing({state,commit}){
      commit('teardownResurfacing',{
        featureAttributes: {
          "OBJECTID": null,
          "DEFECT_ID": null,
          "DEFECT_TYPE": null,
          "DATE_REPORTED": null,
          "HD_REF": null,
          "WR_REF": null,
          "PAVE_TYPE": null,
          "LENGTH": null,
          "WIDTH": null,
          "SEVERITY": null,
          "MAINT_ID": null,
          "MATERIAL": null,
          "REMARK": null,
          "PHOTO_LINK": null,
          "REPORT_LINK": null,
          "SR_NO": null,
          "AOD": null,
          "UPD_BY": null,
          "UPD_DATE": null
        },
        rings:[]
      })
    },
    setupFeature({state,commit}, resurfacingGraphic){
      
      var a = Object.assign({}, resurfacingGraphic.attributes);
      delete a['_geometry'];

      var resurfacingGraphicClone = {
        attributes: a,
        geometry: resurfacingGraphic.geometry
      }

      commit('setupFeature',resurfacingGraphicClone)

        //TBD redraw graphic
    },

    addCoordinate({ state, commit }, coordinate){

        //slice(0) to clone the rings array
        var modifiedRings = state.rings.slice(0)

        //push the new coordinate
        modifiedRings.push([coordinate.x,coordinate.y]);

        //debugger;
        return isSimple(modifiedRings).then(function(result){
          commit('pushCoordinateToRing',coordinate)          
          // if(result){
          //   //add a coordinate to the end of the rings
          //   commit('pushCoordinateToRing',coordinate)
          // }else{
          //   window.alert('it is not simple!')
          // }
          return result
        });


        //TBD redraw graphic
    },
    removeCoordinate({ state, commit }, index){
        
        
        //remove a coordinate at the specific index of the rings
        commit('removeCoordinateFromRing',index)

        //TBD redraw graphic

    },
    updateXCoordinate({state,commit}, xCoordAndIndex){

      var coordinate =   state.rings[xCoordAndIndex.index]  
      coordinate[0] = xCoordAndIndex.x;

      commit('updateCoordinate', { 

        index: xCoordAndIndex.index,
        coordinate: coordinate

      })

    },

    updateYCoordinate({state,commit}, yCoordAndIndex){

      var coordinate = state.rings[yCoordAndIndex.index] 
      coordinate[1] = yCoordAndIndex.y;

      commit('updateCoordinate', { 

        index: yCoordAndIndex.index,
        coordinate: coordinate

      })

    },    
    updateCoordinate({state,commit}, coordinateAndIndex){

      commit('updateCoordinate', { 

        index: coordinateAndIndex.index,
        coordinate: [coordinateAndIndex.x,coordinateAndIndex.y]

      })      
    },
    addCoordinateToRing({state,commit}, coordinateAndIndex){

      commit('addCoordinateToRing', { 

        index: coordinateAndIndex.index,
        coordinate: [coordinateAndIndex.x,coordinateAndIndex.y]

      })      
    },
    updateAttributes({ state, commit }, newAttributeObj){
        
        //update resurfacing feature attributes
        commit('updateAttributes',newAttributeObj)

        //TBD redraw graphic

    },
    applyEdit({ state, commit }){
      //debugger;
      return featureLayerApplyEdits(state.featureAttributes, state.rings)
      
      //fe/atureLayerApplyEdit(null,,)



        //TBD save edit rings and attributes back to database
        //TBD redraw graphic
    },
    rotate({state,commit},rotateDegree){
      //debugger
      rotateRings(state.rings, parseFloat( rotateDegree)).then( (rotatedRings) => {
        console.log('rotatedRings',rotatedRings);
        commit('updateCoordinates', rotatedRings.rings[0] )
      });

    },
    translate({state,commit}, translateParams){
      
      var translatedRings = translateRings(state.rings, translateParams.xTranslate, translateParams.yTranslate);
      console.log('translate',translatedRings);
      commit('updateCoordinates', translatedRings )  
      
      
    },
    updateCoordinates({state,commit}, newGeometry){
      commit('updateCoordinates', newGeometry.rings[0] )
    }
  }
  
  // mutations
  const mutations = {
    addCoordinateToRing(state,newCoordinateAndIndex){
      //https://vuejs.org/v2/guide/list.html#Caveats
      state.rings.splice(newCoordinateAndIndex.index+1, 0 , newCoordinateAndIndex.coordinate)
    },
    pushCoordinateToRing (state, coordinate) {
     state.rings.push( [ parseFloat(coordinate.x), parseFloat(coordinate.y) ] )
    },
    removeCoordinateFromRing(state, index){
     state.rings.splice( index , 1) ;
    },
    updateAttributes(state, newAttributeObj){
      state.featureAttributes = newAttributeObj;
    },
    updateCoordinate(state, newCoordinateAndIndex){
      //https://vuejs.org/v2/guide/list.html#Caveats
      state.rings.splice(newCoordinateAndIndex.index, 1 , newCoordinateAndIndex.coordinate)
    },
    updateCoordinates(state, newCoordinates){
      state.rings = newCoordinates;
    },
    setupFeature(state,resurfacingGraphic){
      state.featureAttributes = resurfacingGraphic.attributes;
      
      var ringLength = resurfacingGraphic.geometry.rings[0].length;

      if(ringLength >= 2){
        var firstCoord = resurfacingGraphic.geometry.rings[0][0];
        var lastCoord = resurfacingGraphic.geometry.rings[0][ringLength-1];
      }

      //if first coord equal last coord, no need to show it to user
      if( ringLength >= 2 && (firstCoord[0] == lastCoord[0]) && (firstCoord[1] == lastCoord[1])){
         //remove the last coord
         resurfacingGraphic.geometry.rings[0].pop();   
         state.rings =resurfacingGraphic.geometry.rings[0];
      }else{
        state.rings = resurfacingGraphic.geometry.rings[0];
      }
      
      
    },
    teardownResurfacing(state, newState){
      Object.assign(state, newState)
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/defects.js